"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3740],{

/***/ 98523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ TruncatedTagsList; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Tag/Tag.tsx
var Tag = __webpack_require__(90202);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/useWindowSize/useWindowSize.tsx
var useWindowSize = __webpack_require__(16485);
;// CONCATENATED MODULE: ./modules/Tags/TruncatedTagsList/hooks.ts


function useTruncatedList(ref) {
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const [hiddenElements, setHiddenElements] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (!ref.current) return;
        const listElements = getListElements(ref.current);
        const listWidth = ref.current.offsetWidth;
        const elements = hideElementsThatNotFit(listElements, listWidth);
        setHiddenElements(elements.hiddenElements);
    }, [
        width
    ]);
    function getListElements(list) {
        return Array.from(list.querySelectorAll("li"));
    }
    function hideElementsThatNotFit(elements, containerWidth) {
        return elements.reduce((acc, el)=>{
            const nextTagsWidth = acc.tagsWidth + el.offsetWidth;
            let nextHiddenElements = acc.hiddenElements;
            if (nextTagsWidth + 120 > containerWidth) {
                el.style.position = "absolute";
                el.style.opacity = "0";
                nextHiddenElements++;
            } else {
                el.removeAttribute("style");
            }
            return {
                tagsWidth: nextTagsWidth,
                hiddenElements: nextHiddenElements
            };
        }, {
            tagsWidth: 0,
            hiddenElements: 0
        });
    }
    return {
        hiddenElements
    };
}

;// CONCATENATED MODULE: ./modules/Tags/TruncatedTagsList/TruncatedTagsList.tsx





const TruncatedTagsList = (param)=>{
    let { tags , color ="gray" , prefixTag , suffixTag , className  } = param;
    const listRef = (0,react.useRef)(null);
    const { hiddenElements  } = useTruncatedList(listRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        ref: listRef,
        className: classnames_default()("max-w-full w-full flex gap-1 overflow-hidden", className),
        children: [
            prefixTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline-block",
                children: prefixTag
            }),
            tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    style: {
                        position: "absolute",
                        opacity: 0
                    },
                    className: "inline-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                        value: tag.name,
                        size: "sm",
                        color: color
                    })
                }, tag.id)),
            suffixTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline-block",
                children: suffixTag
            }),
            hiddenElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                id: "list-counter",
                value: "+ ".concat(hiddenElements, " more"),
                color: "gray"
            })
        ]
    });
};


/***/ }),

/***/ 9382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ MainTabs; },
/* harmony export */   "_": function() { return /* binding */ LinkCounter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66998);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59785);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51516);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






const MainTabs = (param)=>{
    let { links  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative pt-12 mb-10 w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full overflow-x-auto overflow-y-hidden snap-mandatory snap-both",
                children: [
                    links.map((link)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserPageLink, {
                            data: link
                        }, link.href)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute z-10 top-1/2 -right-[16px] -translate-y-1/2 h-[110%] w-[50px] bg-gradient-to-r from-background-basic/25 to-background-basic/95 md:hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-[1.5px] bg-neutral-200 absolute bottom-0 left-0"
            })
        ]
    });
};
function UserPageLink(param) {
    let { data  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const current = router.pathname === data.match;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: data.href,
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("pb-4 px-4 relative z-10 flex items-center snap-start", {
            "border-b-2 border-neutral-600": current
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
            variant: "h5",
            component: "h2",
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("min-w-fit whitespace-nowrap", {
                "text-neutral-900": current,
                "text-neutral-400": !current
            }),
            children: data.text
        })
    });
}
const LinkCounter = (param)=>{
    let { name , counter  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("flex gap-2 items-center"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: name
            }),
            counter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                variant: "bodyLarge",
                className: "block min-w-[32px] h-8 px-2 rounded-full bg-white flex items-center justify-center font-normal",
                children: counter
            })
        ]
    });
};


/***/ }),

/***/ 11676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ProfileAvatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36221);
/* harmony import */ var _NextAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77420);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);





const ProfileAvatar = (param)=>{
    let { src , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_3__/* .CardAvatar */ .V, {
        size: "2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NextAvatar__WEBPACK_IMPORTED_MODULE_4__/* .NextAvatar */ .t, {
                src: src,
                size: "2xl",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("lg:w-[168px] lg:h-[168px] drop-shadow-xl")
            }),
            children
        ]
    });
};


/***/ }),

/***/ 7247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ProfileCover; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ImgixImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86645);




const ProfileCover = (param)=>{
    let { src , className , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative w-full h-[250px] overflow-hidden rounded-b-2xl md:h-[350px] lg:h-[336px] lg:rounded-2xl group bg-neutral-200", className),
        children: [
            src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ImgixImage__WEBPACK_IMPORTED_MODULE_3__/* .ImgixImage */ .T, {
                fill: true,
                src: src,
                alt: "Profile cover",
                className: "object-cover"
            }),
            children
        ]
    });
};


/***/ }),

/***/ 59070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ActionsRow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Share_Share__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* harmony import */ var _Pages_UserPublicProfilePage_path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8471);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96210);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38937);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35368);





const ActionsRow = (param)=>{
    let { user , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Share_Share__WEBPACK_IMPORTED_MODULE_2__/* .Share */ .m, {
                data: {
                    url: (0,_Pages_UserPublicProfilePage_path__WEBPACK_IMPORTED_MODULE_3__/* .useResolveUserPublicProfilePagePath */ .D)(user.cognito_id),
                    title: "".concat(user.name)
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u, {
                    overlay: "Share with friends and family",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_5__/* .IconButton */ .h, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__/* .ShareIcon */ .a, {
                            className: "w-6 h-6 text-primary-500"
                        }),
                        variant: "base"
                    })
                })
            }),
            children
        ]
    });
};


/***/ }),

/***/ 21882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ UserInfoContent; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ./modules/Tags/TruncatedTagsList/TruncatedTagsList.tsx + 1 modules
var TruncatedTagsList = __webpack_require__(98523);
;// CONCATENATED MODULE: ./modules/UserProfile/UserInfo/UserWebsites.tsx



const UserWebsites = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-x-2 flex-wrap w-full justify-center mb-2 md:justify-start",
        children: [
            user.website_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.website_url,
                target: "_blank",
                className: "inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    component: "span",
                    variant: "bodyXL",
                    className: "text-primary-600 underline",
                    children: user.websiteHostname
                })
            }),
            user.website2_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.website2_url,
                target: "_blank",
                className: "inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    component: "span",
                    variant: "bodyXL",
                    className: "text-primary-600 underline",
                    children: user.website2Hostname
                })
            }),
            user.website3_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.website3_url,
                target: "_blank",
                className: "inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    component: "span",
                    variant: "bodyXL",
                    className: "text-primary-600 underline",
                    children: user.website3Hostname
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/SocialIcons/YoutubeOutlineIcon.tsx
var YoutubeOutlineIcon = __webpack_require__(72442);
// EXTERNAL MODULE: ../ui/src/icons/SocialIcons/FacebookOutlineIcon.tsx
var FacebookOutlineIcon = __webpack_require__(7524);
// EXTERNAL MODULE: ../ui/src/icons/SocialIcons/InstagramOutlineIcon.tsx
var InstagramOutlineIcon = __webpack_require__(23914);
// EXTERNAL MODULE: ../ui/src/icons/SocialIcons/TiktokOutlineIcon.tsx
var TiktokOutlineIcon = __webpack_require__(40488);
// EXTERNAL MODULE: ../ui/src/icons/SocialIcons/VimeoOutlineIcon.tsx
var VimeoOutlineIcon = __webpack_require__(56324);
;// CONCATENATED MODULE: ./modules/UserProfile/SocialLinks/SocialLinks.tsx



const SocialLinks = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-6",
        children: [
            user.youtube_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.youtube_url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeOutlineIcon/* YoutubeOutlineIcon */.G, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.facebook_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.facebook_url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookOutlineIcon/* FacebookOutlineIcon */.V, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.instagram_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.instagram_url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramOutlineIcon/* InstagramOutlineIcon */.j, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.tiktok_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.tiktok_url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TiktokOutlineIcon/* TiktokOutlineIcon */.Z, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.vimeo_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: user.vimeo_url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(VimeoOutlineIcon/* VimeoOutlineIcon */.k, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/UserProfile/UserInfo/UserInfoContent.tsx






const UserInfoContent = (param)=>{
    let { user , subscribeButton  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full text-center mt-4 md:text-left md:mt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                component: "h1",
                variant: "h2",
                className: "text-neutral-900max-w-full line-clamp-1 break-all",
                children: user.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                component: "p",
                variant: "captionBase",
                className: "text-neutral-600 mb-4 ",
                children: [
                    user.subscriptionsCount,
                    " subscribers"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                variant: "bodyBase",
                className: "text-neutral-600 mb-4",
                children: user.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-3 mx-auto max-w-[90%] md:mx-0 lg:max-w-[400px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedTagsList/* TruncatedTagsList */.z, {
                    tags: user.tags,
                    className: "justify-center md:justify-start"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserWebsites, {
                user: user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-2 mx-auto w-full md:mx-0 md:justify-between md:flex-row md:pr-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks, {
                        user: user
                    }),
                    subscribeButton
                ]
            })
        ]
    });
};


/***/ }),

/***/ 62649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ UserPageContentWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const UserPageContentWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full relative -top-[110px] md:-top-[150px] mb-4 px-4 md:px-7 lg:px-8 lg:mb-10",
        children: children
    });
};


/***/ }),

/***/ 4976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ UserPageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const UserPageWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full max-w-8xl mx-auto lg:px-10 lg:pt-10 ",
        children: children
    });
};


/***/ }),

/***/ 93540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UserSubpageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const UserSubpageWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "relative w-full md:max-w-[1126px] mx-auto",
        children: children
    });
};


/***/ }),

/***/ 26136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dp": function() { return /* binding */ useUserVideos; },
/* harmony export */   "Gr": function() { return /* binding */ useUserProfile; },
/* harmony export */   "hD": function() { return /* binding */ useCurrentUserProfile; },
/* harmony export */   "s5": function() { return /* binding */ useCurrentUserVideos; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15265);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74992);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94633);
/* harmony import */ var _User__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22535);



const useCurrentUserProfile = ()=>{
    const userApi = new _Api__WEBPACK_IMPORTED_MODULE_0__/* .AccountApi */ .bP();
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const useCurrentUserProfileQuery = ()=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userProfile",
            "me"
        ], async ()=>await userApi.getCurrentAccount().then(_User__WEBPACK_IMPORTED_MODULE_2__/* .User.fromExtendedAccountDto */ .n.fromExtendedAccountDto));
    const useUserProfileMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)((param)=>{
            let { userId , data  } = param;
            return userApi.updateAccount(userId, data);
        }, {
            onSuccess: function(data) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                void queryClient.invalidateQueries();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data, ...args);
            },
            onError
        });
    };
    const useChangeUserPasswordMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)((param)=>{
            let { userId , ...rest } = param;
            return userApi.changePassword(userId, rest);
        }, {
            onSuccess: function(data) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data, ...args);
            },
            onError
        });
    };
    const useDeleteAccountMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)((userId)=>userApi.deleteAccount(userId), {
            onSuccess: function(data) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data, ...args);
            },
            onError
        });
    };
    const useCurrentUserStickersQuery = (pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userStickers",
            "me",
            pagination
        ], async ()=>await userApi.getMyStickers(pagination), {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        });
    };
    const useSubscribeAccountMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)((userId)=>userApi.subscribe(userId), {
            onSuccess,
            onError
        });
    };
    const useCurrentUserSubscribedQuery = (pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)([
            "subscriptions",
            "subscribed",
            "me",
            "infinite"
        ], async (param)=>{
            let { pageParam =pagination  } = param;
            return await userApi.getMySubscribed(pageParam);
        }, {
            getNextPageParam: (param)=>{
                let { meta  } = param;
                return meta.currentPage === meta.totalPages || meta.totalPages === 0 ? undefined : {
                    page: meta.currentPage + 1,
                    limit: meta.itemsPerPage,
                    serach: meta.search
                };
            },
            refetchOnWindowFocus: false,
            keepPreviousData: true
        });
    };
    const useCurrentUserSubscribersQuery = (pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)([
            "subscriptions",
            "subscribers",
            "me",
            "infinite"
        ], async (param)=>{
            let { pageParam =pagination  } = param;
            return await userApi.getMySubscribers(pageParam);
        }, {
            getNextPageParam: (param)=>{
                let { meta  } = param;
                return meta.currentPage === meta.totalPages || meta.totalPages === 0 ? undefined : {
                    page: meta.currentPage + 1,
                    limit: meta.itemsPerPage,
                    serach: meta.search
                };
            },
            refetchOnWindowFocus: false,
            keepPreviousData: true
        });
    };
    const useCurrentUserStickersInfiniteQuery = (pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)([
            "userStickers",
            "me",
            "infinite"
        ], async (param)=>{
            let { pageParam =pagination  } = param;
            return userApi.getMyStickers(pageParam);
        }, {
            getNextPageParam: (param)=>{
                let { meta  } = param;
                return meta.currentPage === meta.totalPages ? undefined : {
                    page: meta.currentPage + 1,
                    limit: meta.itemsPerPage,
                    serach: meta.search
                };
            },
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        });
    };
    const useCurrentUserResourceCountQuery = ()=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userCount",
            "me"
        ], async ()=>await userApi.getMyResourceCount(), {
            refetchOnMount: false,
            refetchOnWindowFocus: false
        });
    };
    return {
        useSubscribeAccountMutationQuery,
        useCurrentUserSubscribedQuery,
        useCurrentUserSubscribersQuery,
        useUserProfileMutationQuery,
        useCurrentUserProfileQuery,
        useChangeUserPasswordMutationQuery,
        useDeleteAccountMutationQuery,
        useCurrentUserStickersQuery,
        useCurrentUserResourceCountQuery,
        useCurrentUserStickersInfiniteQuery
    };
};
const useCurrentUserVideos = ()=>{
    const userApi = new _Api__WEBPACK_IMPORTED_MODULE_0__/* .AccountApi */ .bP();
    const videoApi = new _Api__WEBPACK_IMPORTED_MODULE_3__/* .VideoApi */ .q();
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const useCurrentUserVideosQuery = (pagination)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userVideos",
            "me",
            pagination
        ], async ()=>await userApi.getMyVideos(pagination), {
            keepPreviousData: true
        });
    const useDeleteUserVideoMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)((param)=>{
            let { videoId  } = param;
            return videoApi.delete(videoId);
        }, {
            onSuccess: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                void queryClient.invalidateQueries([
                    "userVideos",
                    "me"
                ]);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(...args);
            },
            onError
        });
    };
    return {
        useCurrentUserVideosQuery,
        useDeleteUserVideoMutationQuery
    };
};
const useUserProfile = ()=>{
    const userApi = new _Api__WEBPACK_IMPORTED_MODULE_0__/* .AccountApi */ .bP();
    const useUserProfileQuery = (id)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userProfile",
            id
        ], async ()=>await userApi.getAccount(id).then(_User__WEBPACK_IMPORTED_MODULE_2__/* .User.fromExtendedAccountDto */ .n.fromExtendedAccountDto), {
            refetchOnMount: false
        });
    const useUserResourceCountQuery = (id)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userCount",
            id
        ], async ()=>await userApi.getUserResourceCount(id), {
            refetchOnMount: false,
            refetchOnWindowFocus: false
        });
    };
    return {
        useUserProfileQuery,
        useUserResourceCountQuery
    };
};
const useUserVideos = ()=>{
    const userApi = new _Api__WEBPACK_IMPORTED_MODULE_0__/* .AccountApi */ .bP();
    const useUserVideosQuery = (id, pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userVideos",
            id,
            pagination
        ], async ()=>await userApi.getUserVideos(id, pagination), {
            refetchOnMount: false,
            keepPreviousData: true
        });
    };
    const useUserStickersQuery = (id, pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "userStickers",
            id,
            pagination
        ], async ()=>await userApi.getUserStickers(id, pagination), {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        });
    };
    const useUserStickersInfiniteQuery = (id, pagination)=>{
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)([
            "userStickers",
            id,
            "infinite"
        ], async (param)=>{
            let { pageParam =pagination  } = param;
            return userApi.getUserStickers(id, pageParam);
        }, {
            getNextPageParam: (param)=>{
                let { meta  } = param;
                return meta.currentPage === meta.totalPages ? undefined : {
                    page: meta.currentPage + 1,
                    limit: meta.itemsPerPage,
                    serach: meta.search
                };
            },
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        });
    };
    return {
        useUserStickersInfiniteQuery,
        useUserVideosQuery,
        useUserStickersQuery
    };
};


/***/ }),

/***/ 16485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        window.addEventListener("resize", handleSize);
        handleSize();
        return ()=>window.removeEventListener("resize", handleSize);
    }, []);
    return windowSize;
}


/***/ }),

/***/ 36221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ CardAvatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const CardAvatar = (param)=>{
    let { children , size ="2xl" , backgroundClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-neutral-100 rounded-full w-fit h-fit backdrop-blur-md group", backgroundWidth(size), backgroundClassName),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative overflow-hidden rounded-full",
            children: children
        })
    });
};
function backgroundWidth(size) {
    switch(size){
        case "xs":
            return "p-1";
        case "sm":
            return "p-1";
        case "md":
            return "p-1";
        case "lg":
            return "p-2";
        case "xl":
            return "p-2";
        case "2xl":
            return "p-3";
        default:
            return "p-5";
    }
}


/***/ }),

/***/ 69193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59785);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);




const Loading = (param)=>{
    let { className , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full text-center my-5 flex justify-center items-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
            component: "span",
            variant: "bodyLarge",
            className: "text-neutral-800 ",
            children: children || "Loading..."
        })
    });
};


/***/ }),

/***/ 96210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var rc_tooltip_assets_bootstrap_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39030);
/* harmony import */ var rc_tooltip_assets_bootstrap_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(rc_tooltip_assets_bootstrap_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var rc_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56114);




const Tooltip = (param)=>{
    let { placement ="top" , trigger =[
        "hover"
    ] , children , destroyTooltipOnHide ={
        keepParent: true
    } , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(rc_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        placement: placement,
        trigger: trigger,
        ...rest,
        children: children
    });
};


/***/ }),

/***/ 56324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ VimeoOutlineIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const VimeoOutlineIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19px",
        height: "19px",
        viewBox: "0 0 20 20",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "currentColor",
                d: "M 10 1.667969 C 14.59375 1.667969 18.332031 5.40625 18.332031 10 C 18.332031 14.59375 14.59375 18.332031 10 18.332031 C 5.40625 18.332031 1.667969 14.59375 1.667969 10 C 1.667969 5.40625 5.40625 1.667969 10 1.667969 Z M 10 0 C 4.476562 0 0 4.476562 0 10 C 0 15.523438 4.476562 20 10 20 C 15.523438 20 20 15.523438 20 10 C 20 4.476562 15.523438 0 10 0 Z M 14.53125 9.867188 C 13.511719 12.039062 11.058594 15 9.503906 15 C 7.972656 15 7.753906 11.738281 6.917969 9.566406 C 6.507812 8.496094 6.242188 8.742188 5.472656 9.28125 L 5 8.675781 C 6.125 7.6875 7.25 6.539062 7.941406 6.476562 C 8.71875 6.398438 9.199219 6.933594 9.378906 8.070312 C 9.613281 9.570312 9.945312 11.890625 10.523438 11.890625 C 10.972656 11.890625 12.082031 10.050781 12.136719 9.390625 C 12.238281 8.425781 11.425781 8.394531 10.726562 8.695312 C 11.839844 5.050781 16.472656 5.722656 14.53125 9.867188 Z M 14.53125 9.867188 "
            })
        })
    });
};


/***/ }),

/***/ 72442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ YoutubeOutlineIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const YoutubeOutlineIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.99935 3.33337C9.99935 3.33337 4.7873 3.33335 3.4873 3.68168C2.7698 3.87335 2.20599 4.438 2.01432 5.15466C1.66599 6.45466 1.66602 10 1.66602 10C1.66602 10 1.66599 13.5454 2.01432 14.8454C2.20599 15.5629 2.77064 16.1267 3.4873 16.3184C4.7873 16.6667 9.99935 16.6667 9.99935 16.6667C9.99935 16.6667 15.2114 16.6667 16.5114 16.3184C17.2281 16.1267 17.7927 15.5621 17.9844 14.8454C18.3327 13.5454 18.3327 10 18.3327 10C18.3327 10 18.3327 6.45466 17.9844 5.15466C17.7927 4.438 17.2281 3.87335 16.5114 3.68168C15.2114 3.33335 9.99935 3.33337 9.99935 3.33337ZM9.99935 5.00004C12.401 5.00004 15.4084 5.11138 16.0801 5.29138C16.2209 5.32888 16.3363 5.44431 16.3747 5.58598C16.5755 6.33431 16.666 8.61837 16.666 10C16.666 11.3817 16.5755 13.6649 16.3747 14.4141C16.3372 14.5549 16.2217 14.6704 16.0801 14.7087C15.4092 14.8887 12.401 15 9.99935 15C7.59852 15 4.59112 14.8887 3.91862 14.7087C3.77779 14.6712 3.66236 14.5558 3.62402 14.4141C3.42319 13.6658 3.33268 11.3817 3.33268 10C3.33268 8.61837 3.42319 6.33435 3.62402 5.58435C3.66152 5.44435 3.77695 5.32888 3.91862 5.29138C4.58945 5.11138 7.59768 5.00004 9.99935 5.00004ZM8.33268 7.11267L8.33268 12.8874L13.3327 10L8.33268 7.11267Z",
            fill: "currentColor"
        })
    });
};


/***/ })

}]);